export const salesReport = {
	title: "Informe de Ventas",
	tabTitle: "Ventas",
	exportButton: "Exportar",
	exportLabelWithFilters: "Informe con filtros seleccionados",
	exportAllSales: "Ventas detalladas",
	exportOthersReportsLabel: "Otros informes",
	exportTotalSales: "Productos vendidos",
	exportDetailedSold: "Ventas Detalladas (Consolidado)",
	exportSoldProductsAnalytic: "Productos Vendidos (Analítico)",
	exportSoldProductsConsolidated: "Productos Vendidos (Consolidado)",
	productsSoldLabel: "Cant productos vendidos",
	subtotalLabel: "Subtotal",
	subtotalTooltip: "Valor unit x Cant vendida",
	discountsLabel: "Descuentos",
	totalProductsSoldLabel: "Total en productos vendidos",
	totalProductsSoldTooltip: "(Valor unit x Cant vendida) - Descuentos",
	allSalesTab: "Ventas detalladas",
	totalSalesTab: "Productos vendidos",
	paymentTypes: {
		bonus: "Bonus",
		fromApp: "Pago en App",
		fromEvent: "Pago en el evento",
		fromOtherEvent: "Pago en otro evento",
		minimumConsumption: "Consumo mínimo",
		post: "Post",
		ppu: "Pre",
	},
	allSales: {
		table: {
			columns: {
				date: "Fecha",
				client: "Cliente",
				document: "Documento",
				employee: "Colaborador",
				products: "Productos",
				paymentType: "Forma de pago",
				isRefunded: "Reembolsado",
				discount: "Descuento",
				transactionValue: "Valor de la transacción",
			},
			total: "Total",
			method: "método",
			methods: "métodos",
			product: "producto",
			products: "productos",
		},
		filters: {
			clientPlaceholder: "Filtrar por cliente",
			employeePlaceholder: "Filtrar por colaborador",
			paymentTypePlaceholder: "Filtrar pago",
		},
	},
	totalSales: {
		groupPlaceholder: "Agrupar por categoría de producto",
		groupByBar: "Agrupar por bar",
		groupByCategory: "Agrupar por categoría de producto",
		noGroup: "Sin agrupamiento",
		transactionPlaceholder: "Filtrar por tipo de transacción",
		productPlaceholder: "Filtrar por producto",
		barPlaceholder: "Filtrar por bar",
		tableProductsSold: {
			sku: "SKU",
			name: "Nombre",
			unitQuantity: "Cant unit",
			unitValue: "Valor unit",
			subtotal: "Subtotal",
			discounts: "Descuentos",
			totalValue: "Valor total",
			addCategory: "Agregar categoría",
			totalInBar: "Total en {{barName}}",
			productImageAlt: "Imagen del producto",
			category: "Categoría",
			values: "{{length}} Valores",
			mountable: "armable",
			noBar: "Sin bar",
		},
		mountableProductsTable: {
			name: "Nombre",
			section: "Sección Armable",
			count: "Cantidad",
		},
	},
};
